import React from "react";
import Helmet from "react-helmet";

export const MetaTitle = ({ children }: { children: string }) => (
  <Helmet defer={false} title={`${children} | metaplane`} />
);

export default MetaTitle;
